import {Routes} from '@angular/router';
import { DashboardComponent } from './startpagina/dashboard.component';

export const dashboardRoutes: Routes = [
    { path: 'dashboard', component: DashboardComponent }
]
